import { DataDisplay, Text } from "@certn/cascadia-react";
import {
  AdjudicationStatus,
  AdjudicationStatusTag,
} from "../../../utils/renderStatusTag";
import { useTranslation } from "react-i18next";
import { array, InferType, number, object, string } from "yup";
import { OutcomeSchema } from "../../adjudication/types";

type Props = {
  adjudicationResults: unknown;
};

const instanceTypeMap = {
  mismatch_count: "Mismatch Count",
  unverified_employment_count: "Unverified Employment Count",
};
const schema = array().of(
  object({
    instance_count: number().required(),
    outcome: OutcomeSchema.required(),
    instance_type: string().oneOf(Object.keys(instanceTypeMap)).required(),
  })
);

const validateAdjudicationResults = (
  adjudicationResults: unknown
): InferType<typeof schema> | null => {
  try {
    return schema.validateSync(adjudicationResults);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export function ParentEmploymentVerificationAdjudicationResults({
  adjudicationResults,
}: Props) {
  const { t } = useTranslation();
  const validatedAdjudicationResults =
    validateAdjudicationResults(adjudicationResults);

  if (!validatedAdjudicationResults) {
    return null;
  }

  return (
    <DataDisplay
      renderTopMargin={false}
      columns={[
        {
          key: "rule",
          name: t("Rule"),
          isRowHeader: true,
          render: ({ rule }) => <Text style="global/body-primary">{rule}</Text>,
          width: "80%",
        },
        {
          key: "outcome",
          name: t("Adjusted score"),
          render: ({ outcome }) =>
            AdjudicationStatusTag(outcome as AdjudicationStatus),
          width: "20%",
        },
      ]}
      rows={validatedAdjudicationResults.map((instance) => ({
        key: instance.instance_type,
        rule: t("{{instanceType}} - {{instanceCount}} instance{{plural}}", {
          instanceType:
            instanceTypeMap[
              instance.instance_type as keyof typeof instanceTypeMap
            ],
          instanceCount: instance.instance_count > 1 ? "2+" : "1",
          plural: instance.instance_count > 1 ? "s" : "",
        }),
        outcome: instance.outcome,
      }))}
    />
  );
}
